import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {Order} from '../../order/models/order';
import {ArrayResponse} from '..';

export const myOrdersActionTypes = {
  LOAD: type('[My Orders] Load'),
  LOAD_SUCCESS: type('[My Orders] Load Success'),
  LOAD_FAIL: type('[My Orders] Load Fail')
};

export class LoadMyOrdersAction implements Action {
  readonly type = myOrdersActionTypes.LOAD;
  constructor(public payload?: string) {}
}

export class LoadMyOrdersSuccessAction implements Action {
  readonly type = myOrdersActionTypes.LOAD_SUCCESS;
  constructor(public payload?:  ArrayResponse<Order>) {}
}

export class LoadMyOrdersFailAction implements Action {
  readonly type = myOrdersActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
